import Icon from "./Icon";
import Button from "./Button";
import Image from "next/image";
import { urlFor } from "../lib/sanityImage";

function slugify(str) {
  return str
    .toLowerCase()
    .replace(/ä/g, "a")
    .replace(/ö/g, "o")
    .replace(/å/g, "a")
    .replace(/[^\w\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");
}

export default function FeaturedServices({ value = [] }) {
  return (
    <section className="page-section" id="services">
      <div className="page-width page-content">
        <h2 className="section-heading md:text-center">Näin palvelemme</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-4 md:mb-6">
          {value.slice(0, 4).map((service, index) => (
            <a
              key={index}
              href={`palvelumme#${slugify(service.title)}`}
              className="flex"
            >
              <div className="bg-brand-primaryLighter">
                {service.image && (
                  <div className="relative w-full h-[200px] md:h-[250px] lg:h-[200px] overflow-hidden">
                    <Image
                      src={urlFor(service.image).width(800).url()}
                      alt={service.title || ""}
                      fill
                      sizes="(min-width: 1024px) 25vw, (min-width: 768px) 50vw, 100vw"
                      className="object-cover"
                    />
                  </div>
                )}
                <div className="p-4">
                  <h3 className="flex items-center gap-x-1 mb-2">
                    <span className="text-xl">{service.title}</span>
                    <Icon name="arrowRight" />
                  </h3>
                  <p>{service.summary}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
        <div className="md:text-center">
          <Button href="/palvelumme">Katso kaikki palvelut</Button>
        </div>
      </div>
    </section>
  );
}
